<template>
  <div class="video-container w-100 h-100">
    <div :id="playerId"></div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {},
  data: function () {
    return {
      updatePositionInterval: null,
      videoPlayer: null,
      state: { time: null },
    };
  },
  beforeDestroy() {
    if (this.updatePositionInterval) {
      clearInterval(this.updatePositionInterval);
    }
  },
  props: ['link', 'playerId', 'shiurId', 'image', 'autoStart', 'startPosition'],
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isUserVerified: 'auth/isUserVerified',
    }),
    ...mapState({
      playing: function (state) {
        return state.videoPlayer.playing;
      },
    }),
  },
  watch: {
    link: function (newVal, old) {
      this.videoPlayer.remove();
      this.setupPlayer();
    },
    playing: function (newVal, old) {
      if (!newVal) {
        if (this.updatePositionInterval) {
          clearInterval(this.updatePositionInterval);
        }
        return this.videoPlayer.pause();
      }

      if (!this.isLoggedIn || !this.isUserVerified) return;
      if (!this.shiurId) return;

      this.updatePositionInterval = setInterval(() => {
        this.updatePositionInUserHistory(parseInt(this.state.time.position));
      }, 5000);
    },
  },
  methods: {
    setupPlayer() {
      this.videoPlayer = jwplayer(this.playerId)
        .setup({
          width: '100%',
          height: '100%',
          image: this.image,
          file: this.link,
        })
        .setConfig([
          {
            playbackRateControls: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
            autoStart: false,
          },
        ])
        .on('ready', () => {
          this.videoPlayer.setVolume(100);
          this.videoPlayer.setPlaybackRate(1);
          if (this.autoStart) {
            this.videoPlayer.play();
          }
        })
        .on('buffer', value => {})
        .on('meta', metadata => {})
        .on('play', value => {
          this.$store.dispatch('player/setStatus', false);
          this.$store.dispatch('videoPlayer/setStatus', true);

          this.$emit('video-play-event');
        })
        .on('pause', () => {
          this.$store.dispatch('videoPlayer/setStatus', false);
        })
        .on('mute', value => {})
        .on('complete', () => {})
        .on('fullscreen', e => {})
        .on('time', time => {
          this.state.time = time;
        });

      if (this.startPosition) {
        this.videoPlayer.seek(this.startPosition);
      }
    },
    updatePositionInUserHistory(position) {
      this.$http
        .put('/api/user-shiurim-history/update', {
          shiur_id: this.shiurId,
          duration_played: position,
        })
        .then(() => (this.sendingDurationUpdate = false));
    },
  },
  mounted: function () {
    this.setupPlayer();
  },
};
</script>
